export var getDelayBeforeExecution = function (faultExecution, faultBeingEditedIndex) {
    var isDelayBeforeExecutionEnabled = Boolean(faultExecution) && faultBeingEditedIndex !== 0;
    var delayBeforeExecutionDefaultValue = 30;
    return {
        isDelayBeforeExecutionEnabled: isDelayBeforeExecutionEnabled,
        delayBeforeExecutionDefaultValue: delayBeforeExecutionDefaultValue
    };
};
